import { useAuthStore } from '../../stores/authStore';
import { LoaderFunction, redirect } from 'react-router-dom';
import { checkAndRefreshToken } from '../../services/authService';

export const authLoader: LoaderFunction = async () => {
  const isLoggedIn = await checkAndRefreshToken();
  const { setIsLoggedIn } = useAuthStore.getState();

  setIsLoggedIn(isLoggedIn);

  if (!isLoggedIn) {
    return redirect("/login");
  }

  return null;
};
